export default __webpack_public_path__ + "static/media/Star.abe99a31.svg";